import { Injectable } from "@angular/core";
import { RestClientService } from "src/app/core/services/rest/rest-client.service";
import { PageDossier } from "../model/page-dossier";
import { Dossier } from "../model/dossier";
import { Request } from "src/app/parametrage/core/model/request";
import { DossierProvision } from "../model/DossierProvision";
import { PageDossierDTO } from "../model/page-DossierDTO";

@Injectable({
  providedIn: "root"
})
export class DossierService {
  constructor(private _restClientService: RestClientService) {}

  findAllPaging(filter, page, size, sortColomun, descending) {
    return this._restClientService.load<PageDossier>(
      "dossier/dossier-pageable" +
        "?filter=" +
        filter +
        "&page=" +
        page +
        "&size=" +
        size +
        "&sortColomun=" +
        sortColomun +
        "&descending=" +
        descending
    );
  }


  findAllPagingDossierProvision(filter, page, size, sortColumn, descending) {
    return this._restClientService.load<PageDossierDTO>(
      "dossier/dossier-pageable-provision" +
        "?filter=" +
        filter +
        "&page=" +
        page +
        "&size=" +
        size +
        "&sortColumn=" +
        sortColumn +
        "&descending=" +
        descending
    );
  }

  findAllPagingByStatutCode(
    filter,
    page,
    size,
    sortColomun,
    descending,
    statutCode
  ) {
    return this._restClientService.load<PageDossier>(
      "dossier/dossier-pageable" +
        "?filter=" +
        filter +
        "&page=" +
        page +
        "&size=" +
        size +
        "&sortColomun=" +
        sortColomun +
        "&descending=" +
        descending +
        "&statutCode=" +
        statutCode
    );
  }

  findAllPagingEligible(filter, page, size, sortColumn, descending) {
    return this._restClientService.load<PageDossierDTO>(
      "dossier/dossier-pageable-eligible" +
        "?filter=" +
        filter +
        "&page=" +
        page +
        "&size=" +
        size +
        "&sortColumn=" +
        sortColumn +
        "&descending=" +
        descending
    );
  }

  findAllPagingDeclasse(
    filter,
    page,
    size,
    sortColumn,
    descending
  ) {
    return this._restClientService.load<PageDossierDTO>(
      "dossier/dossier-pageable-declasse" +
        "?filter=" +
        filter +
        "&page=" +
        page +
        "&size=" +
        size +
        "&sortColumn=" +
        sortColumn +
        "&descending=" +
        descending
    );
  }

  

  findAllPagingRestructure(
    filter,
    page,
    size,
    sortColumn,
    descending
  ) {
    return this._restClientService.load<PageDossierDTO>(
      "dossier/dossier-pageable-restructure" +
      "?filter=" +
      filter +
      "&page=" +
      page +
      "&size=" +
      size +
      "&sortColumn=" +
      sortColumn +
      "&descending=" +
      descending
    );
  }

  getDossierByNumDossier(numDossier) {
    return this._restClientService.load<Dossier>(
      "dossier/dossier-by-numdossier?numDossier=" + numDossier
    );
  }

  getDossierProvision(numDossier) {
    return this._restClientService.load<DossierProvision>(
      "dossier/dossier-provision?numDossier=" + numDossier
    );
  }

  getDossiersByCodeClient(codeClient) {
    return this._restClientService.load<Dossier[]>(
      "dossier/dossier-by-code-client?codeClient=" + codeClient
    );
  }

  findAllImpayeByCodeClient(codeClient) {
    return this._restClientService.load<Dossier[]>(
      "dossier/find-all-impaye-by-code-client?codeClient=" + codeClient
    );
  }

  analyserDossier(numDossier) {
    return this._restClientService.load<void>(
      "dossier/analyser-dossier?numDossier=" + numDossier
    );
  }

  lancerProcedure(numDossier) {
    return this._restClientService.load<Request>(
      "dossier/lancer-procedure?numDossier=" + numDossier
    );
  }

  getDossiersPagingGestionnaire(
    filter,
    codeAgent,
    page,
    size,
    sortColomun,
    descending
  ) {
    return this._restClientService.load<PageDossier>(
      "dossier/dossier-gestionnaire-pageable" +
        "?filter=" +
        filter +
        "&codeAgent=" +
        codeAgent +
        "&page=" +
        page +
        "&size=" +
        size +
        "&sortColomun=" +
        sortColomun +
        "&descending=" +
        descending
    );
  }

  changerStatut(etatCreanceCode: string, numeroDossier: string) {
    return this._restClientService.save<void>(
      `dossier/update-dossier?etatCreanceCode=${etatCreanceCode}&numeroDossier=${numeroDossier}`,
      {}
    );
  }
}
